module.exports = require("k6/execution");